import { createApp } from 'vue';
import SvgToJpgConverter from '@/Components/SvgToJpgConverter.vue';
import '@styles/app.css';

createApp(SvgToJpgConverter).mount('#svg-to-jpg-converter');
